import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles';
import SpecificDataRow from './SpecificDataRow';
import { getEntities as getCalibrationProfiles } from '../../../redux/actions/calibrationProfilesActions';
import { getEntities as getRestaurantZones } from '../../../redux/actions/restautantZones';
import { EditEquipment } from '../../../redux/actions/equipment-specificActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';
import {
  getExpiryTerm,
  getWarrantyInformation,
} from '../../RestaurantDetailsTabs/EquipmentTabRestaurant/helpers/equipmentWarranty';

const EquipmentEditSpecificData = ({
  open,
  handleClose,
  restaurantId,
  handleRefreshOnCreate,
  pieceToEdit,
}) => {
  const { t } = useTranslation();
  const classes = styles();
  const dispatch: any = useDispatch();
  const { selectedLanguage } = useSelector(
    (state: RootStateOrAny) => state.AppReducer.selectedLanguage,
  );
  const zones = useSelector(
    (state: RootStateOrAny) => state.RestaurantZonesReducer.entities,
  );
  const calibrationProfiles = useSelector(
    (state: RootStateOrAny) => state.CalibrationProfilesReducer.entities,
  );
  const [piece, setPiece] = useState<any>({
    ...pieceToEdit,
    restaurant_zone_id: pieceToEdit.restaurant_zone?.id,
    ...getExpiryTerm(
      pieceToEdit?.equipment_date_of_purchase,
      pieceToEdit?.equipment_date_of_expiry,
    ),
  });
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  useEffect(() => {
    if (open && selectedBrand) {
      dispatch(getRestaurantZones(selectedBrand));
      if (selectedBrand === 'TH') {
        dispatch(getCalibrationProfiles(restaurantId));
      }
    }
  }, [open, selectedBrand]);

  const handleChangeTextFields = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const [name, index] = event.target.name.split('-');
    updateEquipmentPiece({ name, index, value: event.target.value });
  };
  const handleChangeSelect = (
    event: React.ChangeEvent<{ value: unknown; name: string }>,
  ) => {
    const [name, index] = event.target.name.split('-');
    updateEquipmentPiece({ name, index, value: event.target.value });
  };

  const handleChangeDateFields = (fieldName, value) => {
    const [name, index] = fieldName.split('-');
    updateEquipmentPiece({ name, index, value });
  };

  function updateEquipmentPiece({ name, index, value }) {
    let warrantyInformation = {};
    console.log(name);
    if (
      [
        'equipment_expiry_term_year',
        'equipment_expiry_term_month',
        'equipment_expiry_term_day',
        'equipment_purchase_date',
        'equipment_date_of_expiry',
      ].includes(name)
    ) {
      const expiryTermEdited = [
        'equipment_expiry_term_year',
        'equipment_expiry_term_month',
        'equipment_expiry_term_day',
      ].includes(name);

      const expiryTermYear =
        name === 'equipment_expiry_term_year'
          ? value
          : piece['equipment_expiry_term_year'];
      const expiryTermMonth =
        name === 'equipment_expiry_term_month'
          ? value
          : piece['equipment_expiry_term_month'];
      const expiryTermDay =
        name === 'equipment_expiry_term_day'
          ? value
          : piece['equipment_expiry_term_day'];
      const dateOfPurchase =
        name === 'equipment_purchase_date'
          ? value
          : piece['equipment_purchase_date'];
      const dateOfExpiry =
        name === 'equipment_date_of_expiry'
          ? value
          : piece['equipment_date_of_expiry'];

      warrantyInformation = getWarrantyInformation({
        dateOfPurchase,
        dateOfExpiry: expiryTermEdited ? null : dateOfExpiry,
        expiryTermYear,
        expiryTermMonth,
        expiryTermDay,
        expiryTerm: piece['equipment_expiry_term'],
      });
      console.log('This is warranty information', warrantyInformation);
    }
    setPiece({
      ...piece,
      [name]: value,
      ...warrantyInformation,
    });
  }

  const clearData = () => {
    handleClose();
    setPiece({
      serial_number: '',
      alternate_name: '',
      restaurant_zone_id: 0,
      equipment_restaurant_id: 0,
      calibration_profile: null,
      equipment_purchase_date: null,
    });
  };

  const SpecificDataStrings = {
    edit_success: 'equipment.editSuccess',
    edit_error: 'equipment.editError',
    edit_title: t('equipment.editTitle'),
    equipment: t('equipment.equipment'),
    no_available: t('equipment.noAvailable'),
    select_options: t('equipment.selectOptions'),
    create_edit_success: t('equipment.createEditSuccess'),
    create_edit_error: t('equipment.createEditError'),
    create_title: t('equipment.createTitle'),
    category: t('equipment.category'),
    supplier: t('equipment.supplier'),
    model: t('equipment.model'),
    search: t('app.common.search'),
    add_more: t('equipment.addMore'),
    cancel: t('app.common.cancel'),
    save: t('app.common.save'),
  };

  const saveEquipmentPieces = async () => {
    const pieceToUpdate = {
      serial_number: piece.serial_number,
      alternate_name: piece.alternate_name,
      restaurant_zone_id: piece.restaurant_zone_id,
      equipment_restaurant_id: piece.equipment_restaurant[0].id,
      equipment_purchase_date: piece.equipment_purchase_date,
      equipment_date_of_expiry: piece.equipment_date_of_expiry,
      equipment_expiry_term: piece.equipment_expiry_term,
    };
    if (selectedBrand === 'TH' && !!piece.calibration_profile) {
      pieceToUpdate['calibration_profile'] = piece.calibration_profile;
    }
    const response: any = await dispatch(
      EditEquipment(piece.equipmentPieceId, pieceToUpdate),
    );
    clearData();
    if (response?.status === 200) {
      dispatch(snackbarShowMessage(SpecificDataStrings.edit_success));
    } else {
      dispatch(snackbarShowMessage(SpecificDataStrings.edit_error));
    }
    handleRefreshOnCreate();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={clearData}
      aria-labelledby="max-width-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title">
          <div className={classes.flexSpaceBetween}>
            <Typography variant="h6">
              {SpecificDataStrings.edit_title}
            </Typography>
            <IconButton
              style={{ position: 'relative', left: '40px' }}
              onClick={clearData}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <div>
          <AppBar position="static">
            <Toolbar variant="dense" className={classes.flexSpaceBetween}>
              <Typography>{SpecificDataStrings.equipment}</Typography>
            </Toolbar>
          </AppBar>
          <Paper>
            <div>
              <SpecificDataRow
                selectedLanguage={
                  selectedLanguage ||
                  localStorage.getItem('selectedLanguage') ||
                  'eng'
                }
                brand={selectedBrand}
                index={0}
                piece={piece}
                handleChangeSelect={handleChangeSelect}
                handleChangeTextField={handleChangeTextFields}
                handleChangeDateField={handleChangeDateFields}
                removeRow={() => {
                  // No-op: Default implementation
                }}
                calibrationProfiles={calibrationProfiles}
                zones={zones}
                removeOption={false}
              />
            </div>
          </Paper>
        </div>
      </DialogContent>
      <DialogActions>
        <Button data-testid="clear-button" onClick={clearData} color="primary">
          {SpecificDataStrings.cancel}
        </Button>
        <Button
          onClick={saveEquipmentPieces}
          color="primary"
          data-testid="save-button"
          disabled={
            !piece.alternate_name ||
            !piece.restaurant_zone_id ||
            piece.alternate_name.length > 100
          }
        >
          {SpecificDataStrings.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EquipmentEditSpecificData;
